import { EventEmitter } from 'events';

import { events as AppEvents } from '../constants/AppConstants';
import AppDispatcher from '../utils/AppDispatcher';

type State = {
  region: string | false;
};

const _state: State = {
  region: false,
};

class ConfigStoreClass extends EventEmitter {
  dispatchToken;

  getRegion() {
    return _state.region;
  }
}

const ConfigStore = new ConfigStoreClass();

ConfigStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.actionType) {
    case AppEvents.REGION:
      _state.region = action.data;
      break;
  }
});

export default ConfigStore;
